module.exports = __webpack_public_path__ + "static/media/juno.47932402.jpg";